import axios from 'axios';

import { authHeader } from '../../helpers/authHeader';
import { gboexResponseErrorServicos } from '../../helpers/response';

const baseAxiosAuthServicos = axios.create({
    baseURL: process.env.REACT_APP_API_SERVICOS
});

baseAxiosAuthServicos.interceptors.request.use(
    async (config) => {
        const auth = authHeader();
        config.headers.Authorization = auth.Authorization;
        config.headers['X-Client'] = 'portal-servicos';
        return config;
    });

baseAxiosAuthServicos.interceptors.response.use(
    async (response) => response,
    async (error) => gboexResponseErrorServicos(error)
);

export default baseAxiosAuthServicos;